(() => {
  'use strict';


  /* =========================================================
     01 — UTILITAIRES
     ========================================================= */

  const $ = (selector, root = document) =>
    root.querySelector(selector);

  const $$ = (selector, root = document) =>
    [...root.querySelectorAll(selector)];

  /*
   * Échappe le contenu texte avant de l'insérer dans du HTML.
   */
  const escapeHTML = (value) => {
    const element = document.createElement('span');

    element.textContent = value || '';

    return element.innerHTML
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;');
  };

  /*
   * Convertit un montant Shopify exprimé en centimes
   * dans la devise active de la boutique.
   */
  const money = (amount) =>
    new Intl.NumberFormat(
      document.documentElement.lang || 'fr-FR',
      {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'EUR'
      }
    ).format(amount / 100);


  /* =========================================================
     02 — CART DRAWER
     PANIER LATÉRAL
     ========================================================= */

  const backdrop = $('[data-cart-backdrop]');

  let lastFocus;


  /* ---------------------------------------------------------
     OUVERTURE DU PANIER
     --------------------------------------------------------- */

  function openCart(added = false) {

    if (!backdrop) return;

    lastFocus = document.activeElement;

    backdrop.hidden = false;

    document.body.style.overflow = 'hidden';

    $('[data-cart-notice]', backdrop).hidden = !added;

    $('[data-cart-close]', backdrop).focus();

    refreshCart();
  }


  /* ---------------------------------------------------------
     FERMETURE DU PANIER
     --------------------------------------------------------- */

  function closeCart() {

    if (!backdrop) return;

    backdrop.hidden = true;

    document.body.style.overflow = '';

    lastFocus?.focus();
  }


  /* ---------------------------------------------------------
     ACTUALISATION DU PANIER
     --------------------------------------------------------- */

  async function refreshCart() {

    if (!backdrop) return;

    const cart = await fetch('/cart.js')
      .then(response => response.json());

    /*
     * Mise à jour du nombre d'articles dans le panier.
     */
    $$('[data-cart-count]').forEach(element => {
      element.textContent = cart.item_count;
    });


    /*
     * Récupération du conteneur des lignes du panier.
     */
    const list = $('[data-cart-lines]');

    list.replaceChildren();


    /* -------------------------------------------------------
       PANIER VIDE
       ------------------------------------------------------- */

    if (!cart.items.length) {

      const empty = document.createElement('div');

      empty.className = 'empty-cart';

      empty.innerHTML = `
        <p>Votre panier est vide.</p>
        <a
          class="underlined-link"
          href="/collections/tous-nos-parfums"
        >
          Découvrir les parfums →︎
        </a>
      `;

      list.append(empty);
    }


    /* -------------------------------------------------------
       LIGNES DU PANIER
       ------------------------------------------------------- */

    for (const line of cart.items) {

      const row = document.createElement('div');

      row.className = 'cart-line';


      /*
       * Image du produit.
       */
      const image = line.image
        ? `<img src="${escapeHTML(line.image)}" alt="">`
        : '';


      /*
       * Construction de la ligne du panier.
       */
      row.innerHTML = `
        <a
          class="cart-line-image"
          href="${escapeHTML(line.url)}"
        >
          ${image}
        </a>

        <div class="cart-line-info">

          <a href="${escapeHTML(line.url)}">
            ${escapeHTML(line.product_title)}
          </a>

          <span>
            ${escapeHTML(line.variant_title || '')}
          </span>

          <div class="cart-line-bottom">

            <div class="cart-qty">

              <button
                type="button"
                data-change="${line.key}"
                data-qty="${line.quantity - 1}"
                aria-label="Diminuer ${escapeHTML(line.product_title)}"
              >
                −
              </button>

              <span>${line.quantity}</span>

              <button
                type="button"
                data-change="${line.key}"
                data-qty="${line.quantity + 1}"
                aria-label="Augmenter ${escapeHTML(line.product_title)}"
              >
                +
              </button>

            </div>

            <button
              type="button"
              class="remove-line"
              data-change="${line.key}"
              data-qty="0"
            >
              Retirer
            </button>

          </div>

        </div>

        <strong>
          ${money(line.final_line_price)}
        </strong>
      `;

      list.append(row);
    }


    /*
     * Affichage du pied du panier uniquement
     * lorsque celui-ci contient des articles.
     */
    $('[data-cart-footer]').hidden = !cart.items.length;

    /*
     * Mise à jour du sous-total.
     */
    $('[data-cart-subtotal]').textContent =
      money(cart.total_price);
  }


  /* =========================================================
     03 — ÉVÉNEMENTS GLOBAUX
     ========================================================= */

  document.addEventListener('click', async (event) => {


    /* -------------------------------------------------------
       OUVRIR LE PANIER
       ------------------------------------------------------- */

    if (event.target.closest('[data-cart-open]')) {
      openCart();
    }


    /* -------------------------------------------------------
       FERMER LE PANIER
       ------------------------------------------------------- */

    if (
      event.target.closest('[data-cart-close]') ||
      event.target === backdrop
    ) {
      closeCart();
    }


    /* -------------------------------------------------------
       MODIFIER UNE QUANTITÉ DU PANIER
       ------------------------------------------------------- */

    const change = event.target.closest('[data-change]');

    if (change) {

      change.disabled = true;

      try {

        const response = await fetch(
          '/cart/change.js',
          {
            method: 'POST',

            headers: {
              'Content-Type': 'application/json'
            },

            body: JSON.stringify({
              id: change.dataset.change,
              quantity: Number(change.dataset.qty)
            })
          }
        );


        if (!response.ok) {
          throw Error(
            'Impossible de modifier le panier.'
          );
        }


        await refreshCart();

      } catch (error) {

        alert(error.message);

      } finally {

        change.disabled = false;
      }
    }


    /* =====================================================
       MENU MOBILE
       ===================================================== */

    const menu = $('[data-mobile-menu]');


    /* -------------------------------------------------------
       OUVRIR LE MENU
       ------------------------------------------------------- */

    if (event.target.closest('[data-menu-open]')) {

      menu.hidden = false;

      $('[data-menu-open]')
        .setAttribute('aria-expanded', 'true');

      $('[data-menu-close]').focus();

      document.body.style.overflow = 'hidden';
    }


    /* -------------------------------------------------------
       FERMER LE MENU
       ------------------------------------------------------- */

    if (event.target.closest('[data-menu-close]')) {

      menu.hidden = true;

      $('[data-menu-open]')
        .setAttribute('aria-expanded', 'false');

      document.body.style.overflow = '';

      $('[data-menu-open]').focus();
    }

  });


  /* =========================================================
     04 — TOUCHE ÉCHAP
     ========================================================= */

  document.addEventListener('keydown', (event) => {

    if (event.key !== 'Escape') return;


    /* -------------------------------------------------------
       FERMER LE PANIER
       ------------------------------------------------------- */

    if (backdrop && !backdrop.hidden) {
      closeCart();
    }


    /* -------------------------------------------------------
       FERMER LE MENU MOBILE
       ------------------------------------------------------- */

    const menu = $('[data-mobile-menu]');

    if (menu && !menu.hidden) {

      menu.hidden = true;

      document.body.style.overflow = '';

      $('[data-menu-open]').focus();
    }

  });


  /* =========================================================
     05 — FORMULAIRE PRODUIT
     VARIANTES / QUANTITÉ / AJOUT AU PANIER
     ========================================================= */

  const form = $('[data-product-form]');


  if (form) {

    const input = $('[data-variant-input]', form);

    const qty = $('[name=quantity]', form);


    /* -------------------------------------------------------
       CHANGEMENT DE VARIANTE
       ------------------------------------------------------- */

    $$('[data-variant-button]', form).forEach(button => {

      button.addEventListener('click', () => {

        input.value = button.dataset.id;


        /*
         * Mise à jour de l'état visuel des variantes.
         */
        $$('[data-variant-button]', form).forEach(other => {

          other.classList.toggle(
            'active',
            other === button
          );

          other.setAttribute(
            'aria-pressed',
            String(other === button)
          );
        });


        /*
         * Disponibilité de la variante.
         */
        const available =
          button.dataset.available === 'true';


        $('[data-availability]', form).textContent =
          available
            ? '● En stock'
            : '○ Rupture de stock';


        /*
         * Activation / désactivation du bouton d'achat.
         */
        $('[data-submit]', form).disabled = !available;


        $('[data-submit]', form).firstChild.textContent =
          available
            ? 'Ajouter au panier '
            : 'Indisponible ';


        /*
         * Mise à jour du prix.
         */
        $$(
          '[data-variant-price], [data-add-price], [data-mobile-price]'
        ).forEach(element => {
          element.textContent = button.dataset.price;
        });


        /*
         * Mise à jour du bouton d'achat mobile.
         */
        $('[data-mobile-add]').disabled = !available;

        $('[data-mobile-add]').textContent =
          available
            ? 'Ajouter au panier'
            : 'Indisponible';
      });

    });


    /* -------------------------------------------------------
       QUANTITÉ — DIMINUER
       ------------------------------------------------------- */

    $('[data-qty-minus]', form).onclick = () => {

      qty.value = Math.max(
        1,
        Number(qty.value) - 1
      );

    };


    /* -------------------------------------------------------
       QUANTITÉ — AUGMENTER
       ------------------------------------------------------- */

    $('[data-qty-plus]', form).onclick = () => {

      qty.value = Math.min(
        10,
        Number(qty.value) + 1
      );

    };


    /* -------------------------------------------------------
       BOUTON MOBILE
       ------------------------------------------------------- */

    $('[data-mobile-add]')?.addEventListener(
      'click',
      () => form.requestSubmit()
    );


    /* -------------------------------------------------------
       AJOUT AU PANIER
       ------------------------------------------------------- */

    form.addEventListener('submit', async (event) => {

      event.preventDefault();


      const submit = $('[data-submit]', form);

      const error = $('[data-form-error]', form);


      submit.disabled = true;

      error.hidden = true;


      try {

        const response = await fetch(
          '/cart/add.js',
          {
            method: 'POST',
            body: new FormData(form)
          }
        );


        if (!response.ok) {

          const data = await response.json();

          throw Error(
            data.description ||
            'Impossible d’ajouter cet article.'
          );
        }


        openCart(true);

      } catch (error) {

        error.textContent = error.message;

        error.hidden = false;

      } finally {

        submit.disabled = false;
      }

    });

  }


  /* =========================================================
     06 — GALERIE PRODUIT
     =========================================================

     IMPORTANT :
     L'image 1 utilise le rendu "detail".
     Les images 2 et 3 utilisent de vraies images <img>.

     CORRECTION :
     Auparavant, lorsque l'utilisateur revenait à l'image 1,
     le script clonait le .af-bottle-render de la miniature.

     Cela transformait donc le rendu "detail" en rendu "thumb"
     et provoquait le mauvais positionnement du flacon.

     On conserve maintenant le rendu principal ORIGINAL afin
     de pouvoir le restaurer exactement lors du retour à
     l'image 1.
     ========================================================= */

  const gallery = $('[data-gallery]');


  if (gallery) {

    const thumbs =
      $$('[data-gallery-thumb]', gallery);

    const main =
      $('[data-gallery-main]', gallery);

    const link =
      $('[data-gallery-open]', gallery);


    /* -------------------------------------------------------
       ÉTAT DE LA GALERIE
       ------------------------------------------------------- */

    let index = 0;

    let manual = false;


    /* -------------------------------------------------------
       RENDU PRINCIPAL ORIGINAL
       -------------------------------------------------------

       On conserve ici une copie du véritable rendu DETAIL
       présent au chargement de la page.

       Il ne faut surtout pas récupérer le rendu depuis
       thumbs[0], car celui-ci est la miniature "thumb".
       ------------------------------------------------------- */

    const originalMain =
      main.firstElementChild.cloneNode(true);


    /* -------------------------------------------------------
       AFFICHER UNE IMAGE
       ------------------------------------------------------- */

    function show(i) {

      index = i;


      /* -----------------------------------------------------
         ÉTAT DES MINIATURES
         ----------------------------------------------------- */

      thumbs.forEach((thumb, number) => {

        thumb.classList.toggle(
          'selected',
          number === i
        );

        thumb.setAttribute(
          'aria-pressed',
          String(number === i)
        );

      });


      /* -----------------------------------------------------
         IMAGE 1 — FLACON PRINCIPAL
         ----------------------------------------------------- */

      if (i === 0) {

        /*
         * IMPORTANT :
         * On restaure le rendu DETAIL original.
         *
         * On ne clone plus thumbs[0], qui est un rendu THUMB.
         */
        main.replaceChildren(
          originalMain.cloneNode(true)
        );

        /*
         * Pas de lien "Lire en grand" pour le flacon.
         */
        link.hidden = true;

      }


      /* -----------------------------------------------------
         IMAGE 2 / IMAGE 3
         ----------------------------------------------------- */

      else {

        const image =
          document.createElement('img');


        image.src =
          thumbs[i].dataset.src;

        image.alt =
          thumbs[i].dataset.alt;


        /*
         * Remplace temporairement le flacon principal
         * par l'image sélectionnée.
         */
        main.replaceChildren(image);


        /*
         * Mise à jour du lien "Lire en grand".
         */
        link.href = image.src;

        link.textContent =
          i === 1
            ? 'Lire les notes olfactives en grand ↗︎'
            : 'Lire le poème en grand ↗︎';

        link.hidden = false;
      }

    }


    /* -------------------------------------------------------
       CLIC SUR UNE MINIATURE
       ------------------------------------------------------- */

    thumbs.forEach((button, i) => {

      button.addEventListener(
        'click',
        () => {

          manual = true;

          show(i);

        }
      );

    });


    /* -------------------------------------------------------
       SWIPE MOBILE
       ------------------------------------------------------- */

    let start = 0;


    main.addEventListener(
      'touchstart',
      event => {

        start =
          event.touches[0].clientX;

      },
      {
        passive: true
      }
    );


    main.addEventListener(
      'touchend',
      event => {

        const diff =
          event.changedTouches[0].clientX - start;


        if (Math.abs(diff) > 50) {

          manual = true;


          show(
            (
              index +
              (diff < 0
                ? 1
                : thumbs.length - 1)
            ) % thumbs.length
          );

        }

      },
      {
        passive: true
      }
    );


    /* -------------------------------------------------------
       ROTATION AUTOMATIQUE DE LA GALERIE
       ------------------------------------------------------- */

    if (
      thumbs.length > 1 &&
      !matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
    ) {

      setInterval(() => {

        if (
          !manual &&
          !document.hidden
        ) {

          show(
            (index + 1) % thumbs.length
          );

        }

      }, 6500);

    }

  }


  /* =========================================================
     07 — CORRESPONDANCES
     ========================================================= */

  $$('.correspondances-steps').forEach(group => {

    $$('[data-step]', group).forEach(button => {

      const activate = () => {

        $$('[data-step]', group).forEach(step => {

          step.setAttribute(
            'aria-pressed',
            String(step === button)
          );

        });


        $('.correspondances-detail', group.parentElement)
          .textContent =
          button.dataset.detail;
      };


      button.addEventListener(
        'click',
        activate
      );


      button.addEventListener(
        'focus',
        activate
      );


      button.addEventListener(
        'pointerenter',
        event => {

          if (event.pointerType === 'mouse') {
            activate();
          }

        }
      );

    });

  });


  /* =========================================================
     08 — REVEAL AU SCROLL
     ========================================================= */

  const reveals = $$('.reveal');


  if (
    'IntersectionObserver' in window &&
    !matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches
  ) {

    const observer =
      new IntersectionObserver(
        entries => {

          entries.forEach(entry => {

            if (entry.isIntersecting) {

              entry.target.classList.add(
                'is-visible'
              );

              observer.unobserve(
                entry.target
              );

            }

          });

        },
        {
          threshold: 0.12
        }
      );


    reveals.forEach(element => {
      observer.observe(element);
    });

  }


  else {

    reveals.forEach(element => {
      element.classList.add('is-visible');
    });

  }


  /* =========================================================
     09 — HEADER
     ========================================================= */

  const header = $('#site-header');


  function updateHeader() {

    if (!header) return;


    /*
     * Header transparent sur la homepage
     * en haut de page.
     */
    header.classList.toggle(
      'header-transparent',
      document.body.dataset.page === 'index' &&
      scrollY <= 40
    );


    /*
     * Header sombre dans la section correspondances.
     */
    const rect =
      $('.correspondances-section')
        ?.getBoundingClientRect();


    header.classList.toggle(
      'header-dark',
      !!rect &&
      rect.top <= 78 &&
      rect.bottom > 78
    );

  }


  addEventListener(
    'scroll',
    updateHeader,
    {
      passive: true
    }
  );


  updateHeader();


  /* =========================================================
     10 — GRILLE CATALOGUE
     FILTRES / TRI / RECHERCHE
     ========================================================= */

  const grid =
    $('[data-catalog-grid]');


  if (grid) {

    const items =
      $$('[data-catalog-item]', grid);


    const fields = [
      'query',
      'type',
      'stock',
      'sort'
    ];


    const state = {
      query: '',
      type: 'all',
      stock: false,
      sort: 'default'
    };


    /* -------------------------------------------------------
       APPLICATION DES FILTRES
       ------------------------------------------------------- */

    function apply() {

      items.forEach(element => {

        element.hidden = !(
          (
            !state.query ||
            element.dataset.title.includes(
              state.query
            ) ||
            element.dataset.description.includes(
              state.query
            )
          ) &&
          (
            state.type === 'all' ||
            element.dataset.type === state.type
          ) &&
          (
            !state.stock ||
            element.dataset.available === 'true'
          )
        );

      });


      /* -----------------------------------------------------
         PRODUITS VISIBLES
         ----------------------------------------------------- */

      const visible =
        items.filter(element => !element.hidden);


      /* -----------------------------------------------------
         TRI
         ----------------------------------------------------- */

      visible
        .sort((a, b) => {

          if (state.sort === 'price-asc') {

            return (
              Number(a.dataset.price) -
              Number(b.dataset.price)
            );

          }


          if (state.sort === 'price-desc') {

            return (
              Number(b.dataset.price) -
              Number(a.dataset.price)
            );

          }


          if (state.sort === 'name') {

            return a.dataset.title.localeCompare(
              b.dataset.title,
              'fr'
            );

          }


          return (
            items.indexOf(a) -
            items.indexOf(b)
          );

        })
        .forEach(element => {
          grid.append(element);
        });


      /* -----------------------------------------------------
         NOMBRE DE RÉSULTATS
         ----------------------------------------------------- */

      $$('[data-result-count]').forEach(element => {

        element.textContent =
          visible.length +
          ' résultat' +
          (visible.length > 1 ? 's' : '');

      });


      /* -----------------------------------------------------
         ABSENCE DE RÉSULTATS
         ----------------------------------------------------- */

      $('[data-no-results]').hidden =
        !!visible.length;

    }


    /* -------------------------------------------------------
       ÉVÉNEMENTS DES FILTRES
       ------------------------------------------------------- */

    fields.forEach(key => {

      $$(`[data-filter-${key}]`).forEach(element => {

        element.addEventListener(
          key === 'query'
            ? 'input'
            : 'change',
          () => {

            state[key] =
              key === 'stock'
                ? element.checked
                : key === 'query'
                  ? element.value.toLocaleLowerCase('fr')
                  : element.value;


            /*
             * Synchronisation des contrôles identiques.
             */
            $$(`[data-filter-${key}]`)
              .forEach(other => {

                if (other === element) return;


                if (key === 'stock') {

                  other.checked =
                    state[key];

                }

                else {

                  other.value =
                    element.value;

                }

              });


            apply();

          }
        );

      });

    });


    /* -------------------------------------------------------
       EFFACER LES FILTRES
       ------------------------------------------------------- */

    $('[data-clear-filters]')
      ?.addEventListener(
        'click',
        () => {

          state.query = '';

          state.stock = false;

          state.type = 'all';


          $$('[data-filter-query]')
            .forEach(element => {
              element.value = '';
            });


          $$('[data-filter-stock]')
            .forEach(element => {
              element.checked = false;
            });


          $$('[data-filter-type]')
            .forEach(element => {
              element.value = 'all';
            });


          apply();

        }
      );


    /* -------------------------------------------------------
       FILTER OVERLAY
       ------------------------------------------------------- */

    const overlay =
      $('[data-filter-overlay]');


    $('[data-filter-open]')
      ?.addEventListener(
        'click',
        () => {
          overlay.hidden = false;
        }
      );


    $$('[data-filter-close]')
      .forEach(button => {

        button.addEventListener(
          'click',
          () => {
            overlay.hidden = true;
          }
        );

      });


    overlay?.addEventListener(
      'click',
      event => {

        if (event.target === overlay) {
          overlay.hidden = true;
        }

      }
    );

  }

})();